import clsx from 'clsx'
import { Product } from 'shopify/api'
import ProductCard from '../ProductCard'

interface ProductListCardProps {
  id: string
  products: Product[]
}

const ProductListCard: React.FC<ProductListCardProps> = ({ id, products }) => {
  return (
    <div
      data-test={`product-list-${id}`}
      className={clsx(
        'gap-3 md:gap-4 grid grid-cols-2 px-4 mt-4',
        'md:grid-cols-4',
        'xl:grid-cols-6'
      )}
    >
      {products.map((node, i) => {
        return <ProductCard key={i} product={node} id={i} />
      })}
    </div>
  )
}

export default ProductListCard
